import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChartCard from '../../components/ChartCard.js';
import KpiCards from './KpiCards.js';
import { SECTION_STATUS } from './useDashboardData.js';
import { CHART_TITLES, DASHBOARD_MESSAGES } from './dashboardConstants.js';
import './PerformanceDashboard.css';

/*
 * このファイルは recharts を読み込まない。App.js が静的に読み込み、画面の部品（recharts を含む）を
 * React.lazy で読み込む間に出す（SCR-P-001 §6.1。最初の読み込みを重くしないため）
 */

const LOADING_SECTION = { status: SECTION_STATUS.LOADING, data: null };

/** 画面の見出しと「← マイページに戻る」（読み込み中も同じ位置に出す） */
export function DashboardPageHeader() {
    const navigate = useNavigate();
    return (
        <div className="detail-header performance-dashboard-header">
            <h1 className="performance-dashboard-title">パフォーマンスダッシュボード</h1>
            <button type="button" className="modal-button-cancel" onClick={() => navigate('/')}>
                ← マイページに戻る
            </button>
        </div>
    );
}

/**
 * 画面の部品を読み込んでいる間の表示（SCR-P-001 §6.1）。
 * API を待っている間と同じスケルトン（KPI カード 4 枚・グラフ 4 枚。決定率トレンドは全幅）を出す
 */
function PerformanceDashboardSkeleton() {
    return (
        <div className="performance-dashboard tablet-ready-page">
            <DashboardPageHeader />
            <KpiCards section={LOADING_SECTION} />
            <div className="dashboard-chart-grid">
                {Object.entries(CHART_TITLES).map(([key, title]) => (
                    <ChartCard
                        key={key}
                        title={title}
                        status={SECTION_STATUS.LOADING}
                        messages={DASHBOARD_MESSAGES}
                        className={key === 'decisionRate' ? 'dashboard-chart-wide' : undefined}
                    />
                ))}
            </div>
        </div>
    );
}

export default PerformanceDashboardSkeleton;
